import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import CourseNavigation from '../components/CourseNavigation/CourseNavigation';
import ExerciseRunner from '../components/ExerciseRunner/ExerciseRunner';

const ExercisePage: React.FC = () => {
  const { courseId, moduleId, exerciseId } = useParams<{
    courseId: string;
    moduleId: string;
    exerciseId: string;
  }>();

  if (!courseId || !moduleId || !exerciseId) {
    return (
      <Container maxWidth='lg' sx={{ py: 4 }}>
        <Typography variant='h4'>Exercise not found</Typography>
      </Container>
    );
  }

  return (
    <>
      <CourseNavigation currentPage='exercise' />
      <ExerciseRunner courseId={courseId} moduleId={moduleId} exerciseId={exerciseId} />
    </>
  );
};

export default ExercisePage;
